<template>
	<div class="base" :class="[ clsDef, loading > 0 ? 'active ' + clsAct : '', contentSize ? 'contentSize' : '', stop ? 'stop' : '' ]">
    <div class="stop" @click="stop()">{{ $t("cancel") }}</div>
		<div class="wrapper" v-if="!hideInside || !loading">
			<slot>
      </slot>
		</div>
	</div>
</template>

<script>
	export default {
		name:  "Loading",
    components: {
    },
		props: {
			clsDef: {
				type: String,
				default: ""
			},
			clsAct: {
				type: String,
				default: ""
			},
			state: {
				type: Boolean,
				default: false
			},
			hideInside: {
				type: Boolean,
				default: false
			},
			contentSize: {
				type: Boolean,
				default: false
			},
      stop: {
			  type: Function,
        default: null
      }
		},
		data() {
			return {
				loading: this.state ? 1 : 0
			};
		},
		methods: {
			set( state, force ) {
				if ( state ) {
					if ( force ) this.loading = 1;
					else this.loading++;
				}
				else {
					if ( force ) this.loading = 0;
					else if ( this.loading > 0 ) this.loading--;
				}
			}
		},
		created() {
			this.$on( "loading", this.set );
		},
		watch: {
			state() {
				this.loading = this.state ? 1 : 0;
			}
		}
	};
</script>

<style scoped>
	.base {
		position: relative;
		box-sizing: border-box;
		width: 100%;
    height: 100%;
	}

	.base.contentSize {
		display: inline-block;
	}

	.base:after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: url( "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2400 2400' width='24' height='24'%3E%3Cg stroke-width='200' stroke-linecap='round' stroke='%23000' fill='none'%3E%3Cpath d='M1200 600V100'/%3E%3Cpath opacity='.5' d='M1200 2300v-500'/%3E%3Cpath opacity='.917' d='M900 680.4l-250-433'/%3E%3Cpath opacity='.417' d='M1750 2152.6l-250-433'/%3E%3Cpath opacity='.833' d='M680.4 900l-433-250'/%3E%3Cpath opacity='.333' d='M2152.6 1750l-433-250'/%3E%3Cpath opacity='.75' d='M600 1200H100'/%3E%3Cpath opacity='.25' d='M2300 1200h-500'/%3E%3Cpath opacity='.667' d='M680.4 1500l-433 250'/%3E%3Cpath opacity='.167' d='M2152.6 650l-433 250'/%3E%3Cpath opacity='.583' d='M900 1719.6l-250 433'/%3E%3Cpath opacity='.083' d='M1750 247.4l-250 433'/%3E%3CanimateTransform attributeName='transform' attributeType='XML' type='rotate' keyTimes='0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667' values='0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199' dur='0.83333s' begin='0s' repeatCount='indefinite' calcMode='discrete'/%3E%3C/g%3E%3C/svg%3E" ) 50% 50% no-repeat;
		background-size: 32px;
		z-index: 100000;
		opacity: 0;
		visibility: hidden;
		transition: visibility 0ms linear 300ms,opacity 300ms linear 0ms;
		pointer-events: none;
	}

	.base.active {
		min-height: 64px;
		min-width: 64px;
	}

	.base.active:after {
		transition: visibility 0ms linear 0ms,opacity 300ms linear 0ms;
		visibility: visible;
		opacity: 1;
	}

	.base.active > .wrapper {
		opacity: 0.2;
		pointer-events: none;
	}

	.base > .wrapper {
		display: inline-block;
		position: relative;
		transition: opacity 300ms linear;
		min-width: 100%;
    min-height: 100%;
		width: 100%;
    height: 100%;
	}

  .base > .stop {
    visibility: hidden;
    opacity: 0;
		transition: visibility 0ms linear 0ms,opacity 300ms linear 0ms;
    position: absolute;
    z-index: 1;
    top: calc( 50% - 2.5em );
    left: 50%;
    transform: translate( -50%, -50% );
    fill: #FF0000;
    cursor: pointer;
    border-radius: 0.2em;
    background-color: #FF0000;
    color: #FFFFFF;
    font-weight: bold;
    padding: 0.2em 0.5em;
    text-align: center;
    box-shadow: 0 0 3px rgba( 0, 0, 0, 0.5 );
    pointer-events: none;
  }

  .base > .stop:active {
    margin: 1px 0 0 1px;
  }

  .base.stop.active > .stop {
		visibility: visible;
		opacity: 1;
    pointer-events: all;
  }
</style>
